import { Service } from '../Service'

const ENDPOINTS = {
  GET: 'Companies/Get',
  GET_DYNAMIC: 'Companies/GetAllDynamic',
  POST: 'Companies/Create',
  PATCH: 'Companies/Patch',
  PUT: 'Companies/Put',
  DELETE: 'Companies/Delete'
}

class ModuleServiceCompanies extends Service {
}

export const ServiceCompanies = new ModuleServiceCompanies({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})
